module.exports = __webpack_public_path__ + "img/developers-icon-active.1ee60433.svg";